<!--
 *                                                     __----~~~~~~~~~~~------___
 *                                    .  .   ~~//====......          __--~ ~~
 *                    -.            \_|//     |||\\  ~~~~~~::::... /~
 *                 ___-==_       _-~o~  \/    |||  \\            _/~~-
 *         __---~~~.==~||\=_    -_--~/_-~|-   |\\   \\        _/~
 *     _-~~     .=~    |  \\-_    '-~7  /-   /  ||    \      /
 *   .~       .~       |   \\ -_    /  /-   /   ||      \   /
 *  /  ____  /         |     \\ ~-_/  /|- _/   .||       \ /
 *  |~~    ~~|--~~~~--_ \     ~==-/   | \~--===~~        .\
 *           '         ~-|      /|    |-~\~~       __--~~
 *                       |-~~-_/ |    |   ~\_   _-~            /\
 *                            /  \     \__   \/~                \__
 *                        _--~ _/ | .-~~____--~-/                  ~~==.
 *                       ((->/~   '.|||' -_|    ~~-/ ,              . _||
 *                                  -_     ~\      ~~---l__i__i__i--~~_/
 *                                  _-~-__   ~)  \--______________--~~
 *                                //.-~~~-~_--~- |-------~~~~~~~~
 *                                       //.-~~~--\
 *                       ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * 
 *                               神兽保佑            永无BUG
 * 
 * @Author: xupeng ‘18309854921@163.com’
 * @Date: 2024-09-02 13:47:07
 * @LastEditors: xupeng ‘18309854921@163.com’
 * @LastEditTime: 2024-12-04 14:52:06
 * @FilePath: \admin\src\views\warehouse\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 -->

<template>
    <div class="page_body">

        <div class="data_main">
            <div class="data_search" v-if="power.indexOf('1')>=0">
                <el-form ref="listQuery" :inline="true" :model="listQuery" size="small" label-width="72px">
                    <el-form-item label="仓库名称：" prop="name">
                        <el-input v-model="listQuery.name" placeholder="请输入仓库名称" @keyup.enter.native="toSearchList"></el-input>
                    </el-form-item>
                    <el-form-item class="last">
                        <el-button type="primary" :loading="isSearchLoading" @click="toSearchList()">查 询</el-button>
                        <el-button @click="$refs['listQuery'].resetFields()">重 置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="data_group" :class="power.indexOf('1')>=0?'mt18':''">
                <el-button type="primary" size="small" @click="postWarehouse" v-if="power.indexOf('2')>=0">同步</el-button>
            </div>

            <div class="data_table mt18">
                <el-table :data="listData" style="width: 100%" v-loading="isRequestLoading">
                    <el-table-column prop="warehouseName" label="仓库名称" min-width="120px" align="center"></el-table-column>
                    <el-table-column prop="availableQty" label="仓内库存" min-width="60px" align="center">
                      <template slot-scope="scope">
                      <span>{{scope.row.availableQty?scope.row.availableQty:'0'}}</span>
                    </template>
                    </el-table-column>
                    <el-table-column prop="province" label="所属地域" min-width="90px" align="center"></el-table-column>
                    <el-table-column prop="address" label="仓库地址" min-width="180px" align="center"></el-table-column>
                    <el-table-column label="操作" align="center" width="100">
                      <template slot-scope="scope">
                        <el-button type="text" @click="toDetail(scope.row.id)">详情</el-button>
                      </template>
                    </el-table-column>
                </el-table>
            </div>

            <pagination :size="listQuery.pageSize" :total="pages.total" :current="listQuery.page" :pages="pages.pages" @pageChange="pageChange"/>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination'
import {getWarehouse,postWarehouse} from '@/api/index'
import {mapState} from "vuex";
export default {
  name: "contentArticleIndex",
  data () {
    return {
      listQuery: {
        name: '',
        page: 1,
        pageSize: 10
      },
      pages: {
        total: 0,
        pages: 0
      },
      isSearchLoading: false,
      isRequestLoading: false,
      listData: [],
      power:null
    }
  },
  computed: {
    ...mapState({
      listKeepAlive: state => state.app.listKeepAlive,
    })
  },
  activated () {
    this.getWarehouse()
  },
  created(){
    this.power = JSON.parse(localStorage.getItem('userRole')).power[3]
  },
  methods: {
    pageChange (e) {
      this.listQuery.page = e.current
      this.listQuery.pageSize = e.size
      this.getWarehouse()
    },
    toSearchList () {
      this.listQuery.page = 1
      this.isSearchLoading = true
      this.getWarehouse()
    },
    toDetail (id) {
      this.$router.push({path: '/warehouse/detail', query: {id: id}})
    },
    getWarehouse(){
      getWarehouse(this.listQuery).then(res=>{
        this.isSearchLoading = false
        console.log(res)
        this.listData = res.data.records
        this.pages.total = res.data.total
        this.pages.pages = res.data.pages
      }).catch(()=>{
        this.isSearchLoading = false
      })
    },
    postWarehouse(){
      postWarehouse({}).then(res=>{
        if (res.code == 0) {
          this.$message.success('同步成功')
          this.listQuery.page = 1
          this.getWarehouse()
        }
      })
    },
  },
  components: {
    pagination
  }
}
</script>
